<ng-container *transloco="let t">
  <form *ngIf="options" (submit)="onSubmit()" novalidate>

    <p class="p-mb-4">{{ t('finish_order.messages.intro') }}</p>

    <p-table [value]="candidates">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ t('common.labels.name') }}</th>
          <th>{{ t('common.labels.result') }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-candidate>
        <tr>
          <td><p>{{ candidate.fullname }}</p></td>
          <td>
            <app-form-control [control]="candidate.control" type="select" [options]="options?.recommendations" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [noMargin]="true" [showLabel]="false"></app-form-control>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="2">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="p-mt-4 p-text-right">
      <app-form-buttons [submitting]="submitting" [submitLabel]="t('common.labels.save_and_finish')" (cancelled)="onCancel()"></app-form-buttons>
    </div>

  </form>
</ng-container>
